import React from 'react';
import DetailListContent from './DetailListContent';
import { DetailListProvider } from './DetailListContext';

const DetailList = () => {
  return (
    <DetailListProvider>
      <DetailListContent />
    </DetailListProvider>
  );
};

export default DetailList;
